export default __webpack_public_path__ + "i18n/translation-pl.4ba02afc.json";